import * as React from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { ConnectionStatus } from 'fk-cp-chat';
import shallowEqual from 'utils/shallowEqual';
import StringWidget from 'components/StringWidget/StringWidget';
import Loader from 'components/Common/Loader/Loader';
import ConnectedIcon from 'images/chat/tick-icon.svg';
import styles from './ChatStatusMessage.css';
const DISMISS_DELAY = 3000;
const { CONNECTED, CONNECTING, DISCONNECTED } = ConnectionStatus;
var messageColorCodeEnum;
(function (messageColorCodeEnum) {
    messageColorCodeEnum["GREEN"] = "GREEN";
    messageColorCodeEnum["RED"] = "RED";
})(messageColorCodeEnum || (messageColorCodeEnum = {}));
export default class ChatStatusMessage extends React.Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.displayStatus = (newStatusMsg, connectionStatus) => {
            if (connectionStatus === CONNECTED) {
                // Dismiss the status message after DISMISS_DELAY ms if the new connection status is CONNECTED.
                this.timer = window.setTimeout(() => {
                    this.setState({ showStatus: false });
                    this.timer = null;
                }, DISMISS_DELAY);
            }
            else if (this.timer !== null) {
                window.clearTimeout(this.timer);
                this.timer = null;
            }
            this.setState({
                statusMsg: newStatusMsg,
                showStatus: true,
                messageColorCode: connectionStatus === CONNECTED ? messageColorCodeEnum.GREEN : messageColorCodeEnum.RED
            });
        };
        this.getStatusMessage = (prevState, currState) => {
            if (currState === DISCONNECTED || currState === CONNECTING) {
                return 'chatNetworkDisrupted';
            }
            else if ((prevState === DISCONNECTED || prevState === CONNECTING) && currState === CONNECTED) {
                return 'chatNetworkReconnected';
            }
            return '';
        };
        this.state = {
            statusMsg: this.getStatusMessage(null, props.connectionStatus),
            showStatus: false,
            messageColorCode: messageColorCodeEnum.GREEN
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const prevConnectionStatus = get(this.props, 'connectionStatus');
        const connectionStatus = get(nextProps, 'connectionStatus');
        if (prevConnectionStatus !== connectionStatus) {
            const newStatusMsg = this.getStatusMessage(prevConnectionStatus, connectionStatus);
            if (!isEmpty(newStatusMsg) && newStatusMsg !== this.state.statusMsg) {
                this.setState({ showStatus: false });
                // If a message is already being displayed, it's first slid up before sliding down the next message. The setTimout delay here is equal to the slide animation duration.
                if (this.state.showStatus) {
                    window.setTimeout(() => {
                        this.displayStatus(newStatusMsg, connectionStatus);
                    }, 200);
                }
                else {
                    this.displayStatus(newStatusMsg, connectionStatus);
                }
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
    }
    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
    render() {
        const { statusMsg, showStatus, messageColorCode } = this.state;
        return (<div className={cx(styles['chat-status-message'], {
            [styles['connected']]: messageColorCode === messageColorCodeEnum.GREEN,
            [styles['show']]: showStatus
        })}>
				<StringWidget strKey={statusMsg}/>
				<div className={styles['icon-wrapper']}>
					{messageColorCode === messageColorCodeEnum.GREEN && <img className={styles['icon']} src={ConnectedIcon}/>}
					{this.props.connectionStatus === CONNECTING && messageColorCode === messageColorCodeEnum.RED && (<Loader stroke="#fff" className={styles['loader-icon']}/>)}
				</div>
			</div>);
    }
}
